<template>
  <div>
    <b-row
      :class="'row-container tw-flex tw-flex-row tw-gap-[40px] tw-mr-0 tw-ml-0'"
    >
      <b-col :class="'tw-pr-0 tw-pl-0 tw-flex tw-items-center'">
        <label
          :class="[
            'tw-mb-0 tw-text-[14px] tw-text-[#231F20] tw-leading-[145%] tw-font-medium tw-font-Poppins',
            classTitle,
          ]"
          >{{ title }}</label
        >
        <span v-if="required" class="tw-text-[red]">&nbsp;*</span>
      </b-col>

      <b-col :class="'col-sm-6 tw-pr-0 tw-pl-0'">
        <div class="dropdown">
          <BaseDropDown
            :id="id"
            v-model="value"
            :data="data || []"
            :bg-dropdown="validation?.$errors[0] ? '' : '#eff0f180'"
            :validation="{}"
            :class-name="`gray-dropdown-container-wizard tw-h-[58px] !tw-flex ${
              validation?.$errors[0] ? 'is-invalid-input' : ''
            } ${isApiError ? 'is-api-error' : ''}`"
            :placeholder="placeholder"
            :use-visual-scroll="useVisualScroll"
            @update:model-value="(e) => selectValue(e)"
          />
        </div>
      </b-col>
    </b-row>
    <b-row class="align-items-center">
      <b-col :class="'col-container tw-pr-0 tw-pl-0 tw-flex tw-items-center'" />
      <b-col :class="'col-sm-6 tw-pr-0 tw-pl-0'">
        <slot name="feedback">
          <b-form-invalid-feedback
            v-if="
              !isFocus ||
              (isFocus && validation?.$errors?.[0]?.$validator === 'required')
            "
            :class="{ 'is-invalid': validation?.$error }"
          >
            <VRuntimeTemplate :template="validation?.$errors?.[0]?.$message" />
          </b-form-invalid-feedback>
        </slot>
      </b-col>
    </b-row>
  </div>
</template>

<script setup lang="ts">
import { PropType, computed, ref } from "vue";
import BaseDropDown from "@/components/common/form/baseDropDown.vue";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import VRuntimeTemplate from "vue3-runtime-template";

const props = defineProps({
  id: { type: String, required: true },
  title: { type: String, required: true },
  data: { type: Array as PropType<IDropDownData[]>, required: true },
  placeholder: { type: String, required: false, default: "" },
  classTitle: { type: String, required: false, default: "" },
  required: { type: Boolean, required: false, default: false },
  modelValue: {
    type: String,
    default: () => {
      return null;
    },
  },
  validation: { type: Object, required: false, default: null },
  isApiError: { type: Boolean, required: false, default: false },
  useVisualScroll: { type: Boolean, required: false, default: false },
});
const isFocus = ref(false);
const emit = defineEmits(["update:modelValue", "update:valueTeamPage"]);

const value = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit("update:modelValue", newValue);
  },
});

const selectValue = (value: IDropDownData) => {
  emit("update:modelValue", value);
  emit("update:valueTeamPage", value);
};
</script>

<style scoped>
.is-invalid-input {
  border: 1px solid #f7553c;
  background: #fee5e2;

  &::after {
    content: "";
  }
}

.baseDropDown.gray-dropdown-container .btn-secondary {
  padding: 12px !important;
}
@media screen and (max-width: 600px) {
  .row-container {
    flex-direction: column;
    gap: 20px;

    .col-sm-6 {
      max-width: 100%;
    }
  }
  .col-container {
    display: none;
  }
  .invalid-feedback {
    margin-left: 15px;
  }
}
</style>
